import { LINK_TYPES } from '../config/entityTypeRegistry';

/**
 * Helpers for connection registry trip write/read modes.
 */

/**
 * @param {{ writeMode?: string }} config
 * @returns {boolean}
 */
export function shouldRouteThroughRegistry(config) {
  return config?.writeMode === 'dual_write' || config?.writeMode === 'registry_only';
}

/**
 * @param {{ writeMode?: string }} config
 * @returns {boolean}
 */
export function shouldWriteLegacy(config) {
  return config?.writeMode === 'dual_write';
}

/**
 * @param {{ readMode?: string }} config
 * @returns {boolean}
 */
export function shouldReadFromRegistry(config) {
  return config?.readMode === 'registry_primary' || config?.readMode === 'registry_only';
}

/**
 * @param {{ readMode?: string }} config
 * @returns {boolean}
 */
export function shouldFallbackToLegacyReads(config) {
  return config?.readMode === 'registry_primary';
}

/**
 * Picks the registry link type a manually-created ("Link Entities") pair should use.
 * Falls back to associated_with for same-type or otherwise untyped pairs (place<->place,
 * travel<->day, travel<->place — the last needs a direction the linker UI doesn't collect,
 * see Issue 7/N4). Without this, every manual link landed as associated_with even for
 * pairs the registry has a dedicated type for, so list/lookup helpers that only read the
 * typed link (e.g. the accommodation list's location, located_in dedup) never saw it.
 * @param {string} sourceEntityType
 * @param {string} targetEntityType
 * @returns {string}
 */
export function resolveManualLinkType(sourceEntityType, targetEntityType) {
  if (sourceEntityType === 'document' || targetEntityType === 'document') {
    return LINK_TYPES.DOCUMENT_FOR;
  }
  const pair = new Set([sourceEntityType, targetEntityType]);
  if (pair.has('accommodation') && pair.has('place')) {
    return LINK_TYPES.LOCATED_IN;
  }
  if (pair.has('accommodation') && pair.has('day')) {
    return LINK_TYPES.STAYS_ON;
  }
  return LINK_TYPES.ASSOCIATED_WITH;
}
